import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ predefine, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-color-picker')
    child.attrs.predefine = predefine
    this.children = [child]
  }
}
